import { TextField, TextFieldProps } from '@mui/material'
import React from 'react'

const TextFieldWrapper = React.forwardRef<HTMLDivElement, TextFieldProps>(
  (props, ref) => <TextField {...props} ref={ref} />,
)

export default TextFieldWrapper
